<template>
  <v-container fluid>
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("status") }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="py-0">
            <v-col cols="auto" class="py-0">
              <span class="mt-0 pt-0 mr-4 d-inline float-left"
                >{{ $t("status") }}:</span
              >
              <v-switch
                class="mt-0 pt-0 mr-4 d-inline float-left"
                v-model="item.status"
                :label="item.status ? $t('active') : $t('inactive')"
                color="primary"
                hide-details
              ></v-switch>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="py-0">
              <v-btn
                color="success"
                text
                rounded
                @click="bulkAction('status')"
                >{{ $t("applyOnSelected") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="mode === 'dailyMenu'">
        <v-expansion-panel-header>{{ $t("archive") }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="py-0">
            <v-col cols="auto" class="py-0">
              <span class="mt-0 pt-0 mr-4 d-inline float-left"
                >{{ $t("archive") }}:</span
              >
              <v-checkbox
                class="mt-0 pt-0 mr-4 d-inline float-left"
                v-model="item.archived"
                :label="$t('archived')"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="py-0">
              <v-btn
                color="success"
                text
                rounded
                @click="bulkAction('archived')"
                >{{ $t("applyOnSelected") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t("deliveryOptions")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="py-0">
            <v-col cols="auto" class="py-0">
              <span class="mt-0 pt-0 mr-4 d-inline float-left"
                >{{ $t("deliveryOptions") }}:</span
              >
              <v-checkbox
                class="mt-0 pt-0 mr-4 d-inline float-left"
                v-model="item.allowedDeliveryMethods.takeaway"
                :label="$t('takeaway')"
                color="primary"
                hide-details
              ></v-checkbox>
              <v-checkbox
                class="mt-0 pt-0 mr-4 d-inline float-left"
                v-model="item.allowedDeliveryMethods.delivery"
                :label="$t('delivery')"
                color="primary"
                hide-details
              ></v-checkbox>
              <v-checkbox
                class="mt-0 pt-0 d-inline float-left"
                v-model="item.allowedDeliveryMethods.inplace"
                :label="$t('inplace')"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="py-0">
              <v-btn
                color="success"
                text
                rounded
                @click="bulkAction('allowedDeliveryMethods')"
                >{{ $t("applyOnSelected") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t("restrictions")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                $t("restrictStatus")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="py-0">
                  <v-col class="py-0">
                    <v-checkbox
                      class="pt-0 mt-1"
                      v-model="item.restrictions.statusRestrictions.restrict"
                      :label="$t('restrict')"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="py-0">
                    <v-btn
                      color="success"
                      text
                      rounded
                      @click="bulkAction('restrictions.statusRestrictions')"
                      >{{ $t("applyOnSelected") }}</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row class="py-0 mt-2">
                  <v-col class="py-0">
                    <v-data-table
                      v-if="item.restrictions.statusRestrictions.restrict"
                      :headers="headers"
                      :header-props="{ sortByText: $t('sortBy') }"
                      :items="item.restrictions.statusRestrictions.times"
                      hide-default-footer
                    >
                      <template v-slot:item.day="{ item }">
                        <v-chip small>{{ $t(item.day) }}</v-chip>
                      </template>
                      <template v-slot:item.from="props">
                        <v-edit-dialog :return-value.sync="props.item.from">
                          {{ props.item.from }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.from"
                              :label="$t('from')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:item.to="props">
                        <v-edit-dialog :return-value.sync="props.item.to">
                          {{ props.item.to }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.to"
                              :label="$t('to')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                $t("restrictTakeaway")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="py-0">
                  <v-col class="py-0">
                    <v-checkbox
                      class="pt-0 mt-1"
                      v-model="item.restrictions.takeawayRestrictions.restrict"
                      :label="$t('restrict')"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="py-0">
                    <v-btn
                      color="success"
                      text
                      rounded
                      @click="bulkAction('restrictions.takeawayRestrictions')"
                      >{{ $t("applyOnSelected") }}</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row class="py-0 mt-2">
                  <v-col class="py-0">
                    <v-data-table
                      v-if="item.restrictions.takeawayRestrictions.restrict"
                      :headers="headers"
                      :header-props="{ sortByText: $t('sortBy') }"
                      :items="item.restrictions.takeawayRestrictions.times"
                      hide-default-footer
                    >
                      <template v-slot:item.day="{ item }">
                        <v-chip small>{{ $t(item.day) }}</v-chip>
                      </template>
                      <template v-slot:item.from="props">
                        <v-edit-dialog :return-value.sync="props.item.from">
                          {{ props.item.from }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.from"
                              :label="$t('from')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:item.to="props">
                        <v-edit-dialog :return-value.sync="props.item.to">
                          {{ props.item.to }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.to"
                              :label="$t('to')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                $t("restrictDelivery")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="py-0">
                  <v-col class="py-0">
                    <v-checkbox
                      class="pt-0 mt-1"
                      v-model="item.restrictions.deliveryRestrictions.restrict"
                      :label="$t('restrict')"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="py-0">
                    <v-btn
                      color="success"
                      text
                      rounded
                      @click="bulkAction('restrictions.deliveryRestrictions')"
                      >{{ $t("applyOnSelected") }}</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row class="py-0 mt-2">
                  <v-col class="py-0">
                    <v-data-table
                      v-if="item.restrictions.deliveryRestrictions.restrict"
                      :headers="headers"
                      :header-props="{ sortByText: $t('sortBy') }"
                      :items="item.restrictions.deliveryRestrictions.times"
                      hide-default-footer
                    >
                      <template v-slot:item.day="{ item }">
                        <v-chip small>{{ $t(item.day) }}</v-chip>
                      </template>
                      <template v-slot:item.from="props">
                        <v-edit-dialog :return-value.sync="props.item.from">
                          {{ props.item.from }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.from"
                              :label="$t('from')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:item.to="props">
                        <v-edit-dialog :return-value.sync="props.item.to">
                          {{ props.item.to }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.to"
                              :label="$t('to')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                $t("restrictInplace")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="py-0">
                  <v-col class="py-0">
                    <v-checkbox
                      class="pt-0 mt-1"
                      v-model="item.restrictions.inplaceRestrictions.restrict"
                      :label="$t('restrict')"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="auto" class="py-0">
                    <v-btn
                      color="success"
                      text
                      rounded
                      @click="bulkAction('restrictions.inplaceRestrictions')"
                      >{{ $t("applyOnSelected") }}</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row class="py-0 mt-2">
                  <v-col class="py-0">
                    <v-data-table
                      v-if="item.restrictions.inplaceRestrictions.restrict"
                      :headers="headers"
                      :header-props="{ sortByText: $t('sortBy') }"
                      :items="item.restrictions.inplaceRestrictions.times"
                      hide-default-footer
                    >
                      <template v-slot:item.day="{ item }">
                        <v-chip small>{{ $t(item.day) }}</v-chip>
                      </template>
                      <template v-slot:item.from="props">
                        <v-edit-dialog :return-value.sync="props.item.from">
                          {{ props.item.from }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.from"
                              :label="$t('from')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:item.to="props">
                        <v-edit-dialog :return-value.sync="props.item.to">
                          {{ props.item.to }}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.to"
                              :label="$t('to')"
                              :rules="[rules.required, rules.digitalTime]"
                              single-line
                              rounded
                              filled
                              :hint="$t('toConfirmPressEnter')"
                              persistent-hint
                              class="mt-2"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("options") }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="py-0">
            <v-col cols="6" class="py-0">
              <v-autocomplete
                v-model="item.options"
                :items="availableOptions"
                :label="$t('options')"
                item-text="name"
                item-value="_id"
                filled
                rounded
                chips
                small-chips
                deletable-chips
                multiple
                hide-details
                dense
                single-line
              ></v-autocomplete>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="py-0">
              <v-btn
                color="success"
                text
                rounded
                @click="bulkAction('options')"
                >{{ $t("applyOnSelected") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import restaurantService from "../services/restaurant.service";

export default {
  props: ["mode", "selected", "availableOptions"],
  data() {
    return {
      item: {
        status: true,
        archived: false,
        allowedDeliveryMethods: {
          delivery: true,
          takeaway: true,
          inplace: true,
        },
        restrictions: {
          statusRestrictions: {
            restrict: false,
            times: [
              {
                day: "monday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "tuesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "wednesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "thursday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "friday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "saturday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "sunday",
                from: "00:00",
                to: "23:59",
              },
            ],
          },
          takeawayRestrictions: {
            restrict: false,
            times: [
              {
                day: "monday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "tuesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "wednesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "thursday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "friday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "saturday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "sunday",
                from: "00:00",
                to: "23:59",
              },
            ],
          },
          deliveryRestrictions: {
            restrict: false,
            times: [
              {
                day: "monday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "tuesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "wednesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "thursday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "friday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "saturday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "sunday",
                from: "00:00",
                to: "23:59",
              },
            ],
          },
          inplaceRestrictions: {
            restrict: false,
            times: [
              {
                day: "monday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "tuesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "wednesday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "thursday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "friday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "saturday",
                from: "00:00",
                to: "23:59",
              },
              {
                day: "sunday",
                from: "00:00",
                to: "23:59",
              },
            ],
          },
        },
        options: [],
      },
      headers: [
        { text: this.$t("day"), value: "day", sortable: false },
        { text: this.$t("from"), value: "from", sortable: false },
        { text: this.$t("to"), value: "to", sortable: false },
      ],
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        digitalTime: (value) =>
          /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value) || "HH:MM",
      },
    };
  },
  methods: {
    async bulkAction(type) {
      if (
        window.confirm(
          this.$t("areYouSureYouWantToApplyOnSelected", {
            amount: this.selected.length,
          })
        )
      ) {
        let ids = [];
        this.selected.forEach((e) => {
          ids.push(e._id);
        });

        const getDescendantProp = (obj, path) =>
          path.split(".").reduce((acc, part) => acc && acc[part], obj);

        this.$emit("loading");
        const resp = await restaurantService.bulkAction(
          localStorage.getItem("restaurantId"),
          this.mode,
          ids,
          `${type}`,
          getDescendantProp(this.item, `${type}`)
        );
        return this.$emit("updateItems", resp);
      }
    },
  },
};
</script>

<style scoped>
/* .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
} */
</style>